"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOIN_GROUP_FAILED_ALREADY_IN_GROUP = exports.JOIN_GROUP_FAILED = exports.JOIN_GROUP_SUCCEEDED = exports.JOIN_GROUP_REQUESTED = void 0;
const service_1 = __importDefault(require("../../services/chats/service"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const joinGroup_1 = require("../../services/chats/joinGroup");
const ChatsUpdater_1 = __importDefault(require("../../domain/ChatsUpdater"));
exports.JOIN_GROUP_REQUESTED = "JOIN_GROUP_REQUESTED";
exports.JOIN_GROUP_SUCCEEDED = "JOIN_GROUP_SUCCEEDED";
exports.JOIN_GROUP_FAILED = "JOIN_GROUP_FAILED";
exports.JOIN_GROUP_FAILED_ALREADY_IN_GROUP = "JOIN_GROUP_FAILED_ALREADY_IN_GROUP";
function default_1(chatId) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const state = getState();
        if (chatFunctions.tryGetChat(state.chatsState.chats, chatId)[0]) {
            alert("You are already in this chat");
            return;
        }
        const requestEvent = {
            type: exports.JOIN_GROUP_REQUESTED,
            payload: {
                chatId
            }
        };
        dispatch(requestEvent);
        const result = yield service_1.default.joinGroup(chatId);
        if (result === joinGroup_1.JoinGroupResult.Success) {
            dispatch({
                type: exports.JOIN_GROUP_SUCCEEDED,
                payload: {
                    chatId
                }
            });
            yield ChatsUpdater_1.default.triggerUpdate();
        }
        else if (result === joinGroup_1.JoinGroupResult.AlreadyInGroup) {
            dispatch({
                type: exports.JOIN_GROUP_FAILED_ALREADY_IN_GROUP,
                payload: {
                    chatId,
                    result
                }
            });
        }
        else {
            dispatch({
                type: exports.JOIN_GROUP_FAILED,
                payload: {
                    chatId,
                    result
                }
            });
        }
    });
}
exports.default = default_1;
